import { Navigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from 'router/appRoutes';
import { DetailsTab } from './DetailsTab';
import { DancersTab } from './DancersTab';

const RedirectToPerformanceStudents = () => {
  const { id } = useParams();
  return (
    <Navigate
      to={`/showcases/${id}/students`}
      replace
    />
  );
};

export const pageTabs = [
  {
    title: 'Details',
    path: APP_ROUTES.user.performances.details.info,
    element: <DetailsTab />,
  },
  {
    title: 'Students',
    path: APP_ROUTES.user.performances.details.dancers,
    element: <DancersTab />,
  },
];

export const addictionalRoutes = [
  {
    path: 'dancers',
    element: <RedirectToPerformanceStudents />,
  },
];
